import React, { useState } from 'react';
import { trackFormSubmission } from '../../utils/analytics';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function NewsletterSignup() {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email) {
            console.log('Email submitted:', email);
            trackFormSubmission('Newsletter Signup', true);
            setIsSubmitted(true);
            setEmail('');
        }
    };

    return (
        <section className="newsletter">
            <div className="container">
                <div className="newsletter-content">
                    <h2>Join Our Community</h2>
                    <p>
                        Subscribe to our newsletter to receive the latest health and fitness tips,
                        exclusive content, and special offers directly to your inbox.
                    </p>

                    {isSubmitted ? (
                        <div className="mt-3 p-2 rounded-md" style={{ backgroundColor: 'var(--color-success)', color: 'white' }}>
                            Thank you for subscribing! Check your inbox soon for updates.
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="newsletter-form">
                            <input
                                type="email"
                                placeholder="Your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="form-input"
                            />
                            <button type="submit" className="btn btn-primary">Subscribe</button>
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
}

export default NewsletterSignup;
